module.exports = __webpack_public_path__ + "static/media/b-img-3.87c6420e.png";